export const ADMIN_TAG_LIST_REQUEST = "ADMIN_TAG_LIST_REQUEST";
export const ADMIN_TAG_LIST_SUCCESS = "ADMIN_TAG_LIST_SUCCESS";
export const ADMIN_TAG_LIST_FAIL = "ADMIN_TAG_LIST_FAIL";

export const ADMIN_TAG_CREATE_REQUEST = "ADMIN_TAG_CREATE_REQUEST";
export const ADMIN_TAG_CREATE_SUCCESS = "ADMIN_TAG_CREATE_SUCCESS";
export const ADMIN_TAG_CREATE_FAIL = "ADMIN_TAG_CREATE_FAIL";

export const ADMIN_TAG_READ_REQUEST = "ADMIN_TAG_READ_REQUEST";
export const ADMIN_TAG_READ_SUCCESS = "ADMIN_TAG_READ_SUCCESS";
export const ADMIN_TAG_READ_FAIL = "ADMIN_TAG_READ_FAIL";

export const ADMIN_TAG_UPDATE_REQUEST = "ADMIN_TAG_UPDATE_REQUEST";
export const ADMIN_TAG_UPDATE_SUCCESS = "ADMIN_TAG_UPDATE_SUCCESS";
export const ADMIN_TAG_UPDATE_FAIL = "ADMIN_TAG_UPDATE_FAIL";
export const ADMIN_TAG_UPDATE_RESET = "ADMIN_TAG_UPDATE_RESET";

export const ADMIN_INSTANT_OFF_UPDATE_REQUEST = "ADMIN_INSTANT_OFF_UPDATE_REQUEST";
export const ADMIN_INSTANT_OFF_UPDATE_SUCCESS = "ADMIN_INSTANT_OFF_UPDATE_SUCCESS";
export const ADMIN_INSTANT_OFF_UPDATE_FAIL = "ADMIN_INSTANT_OFF_UPDATE_FAIL";
export const ADMIN_INSTANT_OFF_UPDATE_RESET = "ADMIN_INSTANT_OFF_UPDATE_RESET";

export const ADMIN_ADD_PRODUCT_TAG_REQUEST = "ADMIN_ADD_PRODUCT_TAG_REQUEST";
export const ADMIN_ADD_PRODUCT_TAG_SUCCESS = "ADMIN_ADD_PRODUCT_TAG_SUCCESS";
export const ADMIN_ADD_PRODUCT_TAG_FAIL = "ADMIN_ADD_PRODUCT_TAG_FAIL";

export const ADMIN_ADD_PRODUCTS_TAG_REQUEST = "ADMIN_ADD_PRODUCTS_TAG_REQUEST";
export const ADMIN_ADD_PRODUCTS_TAG_SUCCESS = "ADMIN_ADD_PRODUCTS_TAG_SUCCESS";
export const ADMIN_ADD_PRODUCTS_TAG_FAIL = "ADMIN_ADD_PRODUCTS_TAG_FAIL";

export const ADMIN_REMOVE_PRODUCT_TAG_REQUEST = "ADMIN_REMOVE_PRODUCT_TAG_REQUEST";
export const ADMIN_REMOVE_PRODUCT_TAG_SUCCESS = "ADMIN_REMOVE_PRODUCT_TAG_SUCCESS";
export const ADMIN_REMOVE_PRODUCT_TAG_FAIL = "ADMIN_REMOVE_PRODUCT_TAG_FAIL";

export const ADMIN_REMOVE_PRODUCTS_TAG_REQUEST = "ADMIN_REMOVE_PRODUCTS_TAG_REQUEST";
export const ADMIN_REMOVE_PRODUCTS_TAG_SUCCESS = "ADMIN_REMOVE_PRODUCTS_TAG_SUCCESS";
export const ADMIN_REMOVE_PRODUCTS_TAG_FAIL = "ADMIN_REMOVE_PRODUCTS_TAG_FAIL";
